import { useState, useEffect } from "react";
import { Box, Typography, IconButton, useMediaQuery, Button  } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const HeadlineDisplay = ({ headlines, setSearchQuery }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box sx={{ textAlign: "center", p: 1, maxWidth: "100%", marginBottom: '10px', marginTop: '10px' }}>
      <Typography color="primary" sx={{ fontSize: "1rem", mb: 1, color: '#0066FF' }}>
        Try Fact-Checking These Trending Headlines
      </Typography>

      {/* Both mobile and desktop: Vertical list without internal scrolling */}
      <Box
        sx={{
          textAlign: "left",
          pl: 2,
        }}
      >
        <ul style={{ paddingLeft: "20px", listStyleType: "disc" }}>
          {headlines.map((article, index) => (
            <li key={index}>
              <Typography
                onClick={() => setSearchQuery(article)}
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "primary.main",
                  fontSize: isMobile ? "0.9rem" : "1rem", // Slightly smaller on mobile
                  mb: 1,
                  wordBreak: "break-word", // Ensures long text wraps properly
                }}
              >
                {article}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  );
};

export default HeadlineDisplay;
